module.exports = __webpack_public_path__ + "media/images/cplook/cc-mastercard-5e79f850b3922cfd314bde52d57c0607.gif";